import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  elementShowed,
  initialized,
  playVideo,
  stopPlayVideo,
  showFullScreen,
  hideFullScreen,
} from '../../../store/gallery/';
import { IState } from '../../../store/index';
import { getHittingMicrodataExperiment } from '../../../utils/microdata_experiment';
import { Fotorama, IFotoramaProps } from './fotorama';

type TStoreProps = Pick<
  IFotoramaProps,
  'priceTotalRur' |
  'isNewBuilding' |
  'isApartments' |
  'offerType' |
  'isMicrodataExperimentEnable' |
  'photos' |
  'showElementId' |
  'videos' |
  'floorPlanImage' |
  'isFullScreen'
>;

type TDispatchProps = Pick<
  IFotoramaProps,
  'onElementShowed' |
  'onInitialized' |
  'onPlayVideo' |
  'onStopVideo' |
  'onShowFullScreen' |
  'onHideFullScreen'
>;

export const mapStateToProps = (state: IState): TStoreProps => {
  return {
    priceTotalRur: state.offerData.offer.dealType === 'sale' ? state.offerData.offer.bargainTerms.prices.rur : null,
    isNewBuilding: !!state.offerData.offer.newbuilding,
    isApartments: !!state.offerData.offer.isApartments,
    offerType: state.offerData.offer.offerType,
    isMicrodataExperimentEnable: getHittingMicrodataExperiment(state.experiments),
    photos: state.offerData.offer.photos || [],
    showElementId: state.gallery.showElementId,
    videos: state.offerData.offer.videos || [],
    floorPlanImage: state.newbuildingMvk.offerFloorPlanImage,
    isFullScreen: state.gallery.isFullScreen,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<IState>): TDispatchProps => ({
  onElementShowed: () => dispatch(elementShowed()),
  onInitialized: () => dispatch(initialized()),
  onPlayVideo: () => dispatch(playVideo()),
  onStopVideo: () => dispatch(stopPlayVideo()),
  onShowFullScreen: (id: number) => dispatch(showFullScreen(id)),
  onHideFullScreen: () => dispatch(hideFullScreen()),
});

// tslint:disable-next-line:no-any
export const FotoramaContainer = connect<TStoreProps, TDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Fotorama);
